import styled, { css } from 'styled-components';
import { CaptionRegularM, LabelRegularBoldM } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const KpiResultsCont = styled.div`
  min-height: 328px;
  ${({ theme }: IThemeProvider) => `
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.centy} 0;
  `}
`;

export const KpiChartCont = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.layout.spacing.decy};
  `};
`;

const ChartBackground = css`
  display: flex;
  height: auto;
  flex-flow: column nowrap;
  flex: 1;

  ${({ theme }) => `
    background: ${theme.colors.neutral.primary[0]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: ${theme.layout.spacing.mikro};
    padding: ${theme.layout.spacing.centy} 
    ${theme.layout.spacing.centy} 
    calc(${theme.layout.spacing.centy} + ${theme.layout.spacing.nano}); 
  `}
`;

export const KpiChartBackground = styled.div`
  ${ChartBackground};
`;

export const CurrentKpiChartBackground = styled.div`
  ${ChartBackground};
`;

export const KpiChartTitle = styled(LabelRegularBoldM)`
  letter-spacing: 0.08em;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const KpiDescCont = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mikro} 0 0;
    padding: 0 ${theme.layout.spacing.piko} ${theme.layout.spacing.decy};

    #LinkCont {
      margin-top: ${theme.layout.spacing.nano};
    }
  `}
`;

export const CurrentKpiDesc = styled(CaptionRegularM)`
  margin: auto 0 0;
  font-size: 14px;
  line-height: 18px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

interface IKpiDesc {
  theme: ITheme;
  isExpanded: boolean;
}

export const KpiDesc = styled(CaptionRegularM)<IKpiDesc>`
  flex: 1;
  text-align: justify;
  font-size: 14px;
  line-height: 18px;
  ${({ theme, isExpanded }: IKpiDesc) => `
    margin: 0 0 0 0;
    color: ${theme.colors.neutral.primary[80]};
    ${
  !isExpanded &&
      `
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `
}
  `}
`;

export const KPIMeterCont = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: center;
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.centy} 0;
  `}
`;
